import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import '../../Hospital.css';

const HospitalPage = () => {
  return (
    <>
    <div className="new-home">
    <Header />
      {/* Hero Section */}
      {/* <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title text-red">Best Pregnancy & Maternity Hospital Alternative in
          Pune</h1>
          <p className="hero-text">
          Your gynecologist sees you once a month. But can your pregnancy really wait that long?
          </p>
          <a href="/ElementalCare">
          <button className="cta-button">Get Started With 7 Day Free Care</button>
          </a>
        </div>
        <div className="hero-image">
          <img src="/hospitalpage.png" alt="Pregnant woman with phone" className="pregnant-woman-img" />
        </div>
      </section> */}

      <div className="banner-container position-relative round-back margin-top  ">
        <div className="container-fluid   py-5">
          <div className="row align-items-center ">
            <div className="col-md-6">
              <h1 className="hero-title text-red">
              Best Pregnancy & Maternity Hospital Alternative in Pune
              </h1>
              <p className="under-subtitle py-4 text-gray-600">
              Your gynecologist sees you once a month. But can your pregnancy really wait that long?
              </p>
              <Link to="/Elemental-Care" className="round-btn btn-icon">
              Get Started With 7 Day Free Care
              </Link>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage.png" alt="nt found"></img>
            </div>
          </div>
        </div>
      </div>

     <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage1.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
              Looking for the Best Pregnancy Hospital Near You?
              </h2>

              <p className="bold-font" style={{paddingBottom: "8px"}}>
              If you’re searching for the best pregnancy hospital in Pune, the best maternity hospital near
              me, or a trusted pregnancy hospital near you, you’re likely preparing for the most important
              journey of your life.</p>
              <p className="bold-font" style={{paddingBottom: "8px"}}> At Myprega, we walk that journey with you — every single day.</p>
              <p className="bold-font" style={{paddingBottom: "8px"}}>We’re not just a clinic or a hospital. We’re a complete, prevention focused, digital-first, and
              dable pregnancy care system that gives you quality care, expert attention,
              nience, transparency, simplified end-to-end experience, and daily engagement with
              rs and support — right at your fingertips.</p>
            </div>
          </div>
        </div>
      </div>

     <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
              A New, Better Way to Experience Pregnancy in Pune
              </h2>
              < ul className="expensive-ul">
         <li style={{fontSize: "18px"}}>
                <img
                  src="/tick.png"
                  alt="tick"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
                Traditional pregnancy care models see you once in a few weeks. But at Myprega, we believe in
                everyday care — because pregnancy changes every day.
            </li>
            
            <li style={{fontSize: "18px"}}>
                <img
                  src="/tick.png"
                  alt="tick"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
                Our platform provides end-to-end antenatal care from Day 1 of pregnancy to just before
                delivery. Whether you're planning, expecting, or managing a high-risk condition, we ensure
                affordable, accessible, and continuous care with the warmth and trust you deserve.
            </li>

            <li style={{fontSize: "18px"}}>
                <img
                  src="/tick.png"
                  alt="tick"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
               We are proud to be among the best alternatives to pregnancy hospitals in Pune, offering a
               tech-enabled, human-centric experience designed specially for Pune moms.
            </li>

        </ul>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage2.png" className="w-100" alt="nt found" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage3.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
              Compassionate Care for High-Risk Pregnancies in Pune
              </h2>

          <div className="benefits-list">
            <p className="bold-font">Are you dealing with thyroid,diabetes, BP, PCOS, or complications from past pregnancies?</p>
             <p className="bold-font">Myprega specializes in handling high-risk pregnancies using a combination of:</p>
            <div className="benefit-item">
              <div className="benefit-icon blue">
                <span className="icon">🔬</span>
              </div>
              <div className="benefit-content">
                <p className="benefit-text">Advanced daily vitals monitoring</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon blue">
                <span className="icon">📲</span>
              </div>
              <div className="benefit-content">
                <p className="benefit-text">Real-time symptom tracking through app</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon blue">
                <span className="icon">🧠</span>
              </div>
              <div className="benefit-content">
                <p className="benefit-text">Expert-led early intervention strategies</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon blue">
                <span className="icon">⏰</span>
              </div>
              <div className="benefit-content">
                <p className="benefit-text">Proactive medical support with round-the-clock attention</p>
              </div>
            </div>
              <p className="bold-font">Our coordinated care model ensures you feel safe, supported, and informed, every step of the
                  way — making us one of the best hospitals for high risk pregnancy in Pune, even outside a
                  hospital setup.</p>
          </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
              Expertise That Goes Beyond Just Gynecologist
              </h2>
              <div className="benefits-list">
          <p className="bold-font">Pregnancy is more than just sonographies and gynecologist consultations — it’s a whole new
          phase of life.</p>
          <p className="bold-font">That’s why Myprega brings together a panel of nine medical experts, offering a 360° holistic
                                   care model, all coordinated under one plan. At Myprega, care is delivered by a highly trained
                                   and skilled medical team including:</p>
            <div className="benefit-item">
              <div className="benefit-icon pink">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">MBBS, MD Gynecologists</h3>
                <p className="benefit-text">experienced in both normal & high-risk pregnancy</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon orange">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">Dieticians & Clinical Nutritionists</h3>
                <p className="benefit-text"> for healthy mother and baby</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon green">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">Mental Health Experts</h3>
                <p className="benefit-text">trained in prenatal and postpartum wellness</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon green">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">Lactation Consultants</h3>
                <p className="benefit-text">for smooth breastfeeding journey</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon green">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">Yoga, Garbhasanskar & Wellness Coaches</h3>
                {/* <p className="benefit-text">trained in prenatal and postpartum wellness</p> */}
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon green">
                <span className="icon">✔️</span>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">General Physicians</h3>
                <p className="benefit-text"> for regular health support </p>
              </div>
            </div>

            <p className="bold-font">Every one of our medical professionals is rigorously trained in patient-centered antenatal care
                                     — making us not only a great maternity hospital alternative in Pune, but also a care team
                                     that listens, understands, and supports you fully.</p>
          </div>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage4.png" className="w-100" alt="nt found" />
            </div>
          </div>
        </div>
      </div>


      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage5.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
              The Myprega Difference — Care that Feels Personal
              </h2>

              <p className="bold-font">
              You’re not a case number to us. You’re a mother, a partner, a human with real emotions, real
              doubts, and real dreams.<br/>
              At Myprega, our care is built on three core pillars:
              </p>
              <div style={{marginTop: '18px'}}>
                <div className="benefit-item" style={{paddingBottom: "20px"}}>
                 <div className="benefit-icon green">
                   <span className="icon">✔️</span>
                 </div>
                 <div className="benefit-content">
                   <h3 className="benefit-title">Empathy – We listen first. We make space for your fears, your joys, your worries.</h3>
                 </div>
               </div>
               <div className="benefit-item" style={{paddingBottom: "20px"}}>
                 <div className="benefit-icon blue">
                   <span className="icon">✔️</span>
                 </div>
                 <div className="benefit-content">
                   <h3 className="benefit-title">Trust – You’ll always know who’s caring for you, why they’re recommending something, and
                   what to expect.</h3>
                 </div>
               </div>
               <div className="benefit-item" style={{paddingBottom: "20px"}}>
                 <div className="benefit-icon orange">
                   <span className="icon">✔️</span>
                 </div>
                 <div className="benefit-content">
                   <h3 className="benefit-title">Continuity – No gaps in care. No waiting weeks for the next appointment. We’re with you
                   daily, because your pregnancy is daily.</h3>
                 </div>
               </div>
              </div>
              <p className="bold-font">
              So, if you’re considering a best maternity hospital in Pune, we invite you to try care that
              doesn’t just treat — it truly cares.
              </p>
            </div>
          </div>
        </div>
      </div>

                {/* Common Searches Section */}

      <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
              Common Searches That Lead to Myprega
              </h2>
              <ul className="searches-list">
                <li>best maternity hospital near me</li>
                <li>best hospital for pregnancy</li>
                <li>pregnancy hospital in Pune</li>
                <li>maternity hospital Pune</li>
                <li>best pregnancy hospital in Pune</li>
                <li>pregnancy hospital near me</li>
              </ul>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage6.png" className="w-100" alt="nt found" />
            </div>
          </div>
        </div>
      </div>


      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/hospitalpage7.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
              Trusted by Hundreds of Pune Moms
              </h2>

              <p className="trusted-text">
            Join a growing community of expecting moms in Pune who have chosen Myprega over traditional clinics and
            hospitals
          </p>
          <p className="trusted-subtitle">Our user-friendly web app gives you:</p>
          <ul className="trusted-features">
            <li>
              <span className="check-icon">✓</span>
              <span>Access to 8+ expert specialities</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Daily doctor engagement & health tracking</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Daily garbhsanskar activities</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Personalized weekly action plans</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Mental and physical wellness support</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>One-tap emergency assistance</span>
            </li>
          </ul>
          <p className="trusted-text">
          If you’re looking for a pregnancy hospital in Pune or searching for the best maternity
          hospital in Pune, consider this:
          </p>
          <p className="trusted-text">
          Why wait weeks for a one 15-minute consultation, when your pregnancy needs care
          everyday?
          </p>
            </div>
          </div>
        </div>
      </div>

      <section className="features-section">
        <h2 className="hero-title text-red" style={{textAlign: "center"}}>Take the First Step —7-Day Free Pregnancy Care for Pune Moms</h2>
              <div >
              <p style={{fontWeight: "bold" , textAlign: "center" , fontSize :"20px"}}>Start with a 2-day free pregnancy Care. Try first trust later. || Available for moms across Pune and India || Talk to real doctors, not just content || Get Started With 7 Day Free Care</p>
              </div>
            <div className="cta-features" style={{alignItems: 'center' }}>
            <Link to="/Elemental-Care" className="cta-button">
              Get Started With 7 Day Free Care
              </Link>
          </div>
      </section> 
     <div className="footer-message">
        <p>Myprega is more than a service, it's a companion for your 9-month journey.</p>
      </div>
    <Footer />
    </div>
    </>
  )
}
export default HospitalPage;
